import Link from 'next/link';

import { trackNavigationHeaderClick } from '../../../../../shared';
import type { MenuQuickLink } from '../../../../../types';
import { AccountAction } from './account-action';

import './quick-links.scss';

type QuickLinksProps = {
    links: MenuQuickLink[];
    onLinkSelect: () => void;
};

export function QuickLinks({ links, onLinkSelect }: QuickLinksProps) {
    function handleLinkClick(label: string, url: string) {
        trackNavigationHeaderClick({
            selection: label.toLowerCase(),
            linkUrl: url,
        });
        onLinkSelect();
    }

    return (
        <nav aria-label="Quick links">
            <ul className="mobile-menu-quick-links">
                {links.map(({ label, openInNewTab, url }) => (
                    <li key={url}>
                        <Link
                            href={url}
                            className="mobile-menu-quick-links__link"
                            rel={openInNewTab ? 'noopener noreferrer' : undefined}
                            target={openInNewTab ? '_blank' : undefined}
                            onClick={() => handleLinkClick(label, url)}
                        >
                            {label}
                        </Link>
                    </li>
                ))}
                <li>
                    <AccountAction onLinkSelect={onLinkSelect} />
                </li>
            </ul>
        </nav>
    );
}
